var _desc, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExtendedWarranty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-describedby": "extended-warranty-title extended-warranty-desc",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "extended-warranty-title"
  }, "Extended Warranty") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "extended-warranty-title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "extended-warranty-desc"
  }, "A clock showing the future")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4242 25.4454L21.5352 21.534V11.7559",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4654 36.2143C30.566 36.2143 37.1325 29.647 37.1325 21.5471C37.1325 13.4464 30.566 6.87991 22.4654 6.87991C18.554 6.6854 14.1936 8.13399 11.1531 11.1759C5.42456 16.903 5.28197 26.1905 11.0098 31.9175L13.455 34.3613L15.5135 32.3029H16.5986V42.081H6.81976V41.1034L9.38203 38.4877L6.9587 36.0666C-1.06007 28.0478 -0.948917 15.0464 7.07058 7.02689C11.2577 2.84055 16.5986 0.820868 22.4654 1.01245C33.2211 1.01245 43 10.2063 43 21.5471",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtendedWarranty);
export default __webpack_public_path__ + "static/media/extended-warranty.54538042419504e489b840aa2b9cf70b.svg";
export { ForwardRef as ReactComponent };